import he from 'he';
import fp from 'lodash/fp';
import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { branch, compose, renderComponent, setPropTypes } from 'recompose';
import { cpdPointsSum } from '../../../services';
import { FormGroup, NumberFormField } from '../../components';
import Loading from '../../pages/loading';

const CpdPoints = ({ cpdPoints }) => [
  cpdPoints,
  <i key='label'>
    CPD
    <br />
    hours
  </i>
];

const CpdAllocation = ({
  cpdCategorys,
  industryCpdPoints,
  validationMessages,
  validation,
  onCpdCategorysChange,
  planLocked
}) => (
    <div>
      <Row>
        <Col xs={12}>
          <fieldset className='areas-of-advice'>
            <Row>
              <Col className='align-left' xs={10} xsOffset={1} sm={7} smOffset={0}>
                <h4>CPD category</h4>
              </Col>
              <Col xs={10} xsOffset={1} sm={5} smOffset={0}>
                <h4>CPD hours required</h4>
              </Col>
            </Row>
            <div className='divider' />
            {
              fp.flow(
                fp.sortBy(({ name }) => fp.lowerCase(name)),
                fp.map(({
                  cpdCategoryId: id,
                  name,
                  totalCpdPoints
                }) => (
                    [
                      <Row key={`${id}-row`}>
                        <Col xs={10} xsOffset={1} sm={7} smOffset={0}>
                          <h2 htmlFor={id}>
                            {he.decode(name)}
                          </h2>
                        </Col>
                        <Col xs={10} xsOffset={1} sm={5} smOffset={0}>
                          <NumberFormField
                            id={`area-of-advice-${id}`}
                            label={null}
                            name={id}
                            inputProps={{ disabled: planLocked }}
                            disabled={planLocked}
                            validation={fp.get(id, validationMessages)}
                            value={totalCpdPoints}
                            onChange={onCpdCategorysChange}
                            min={0}
                            formFieldProps={{ formItemProps: { className: 'centered' } }} />
                        </Col>
                      </Row>,
                      <div key={`${id}-divider`} className='divider' />
                    ]
                  )),
                fp.flatten
              )(cpdCategorys)
            }
          </fieldset>
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <div className='form-horizontal'>
            <FormGroup
              id='assigned-points'
              className='assigned-points'
              validation={validationMessages.assignedCpdPoints}
              aria-invalid={!validation.assignedCpdPoints}>
              <Col componentClass='label' sm={6} className='control-label'>
                Assigned CPD hours
              </Col>
              <Col sm={6}>
                <p className='form-control-static'>
                  <CpdPoints cpdPoints={cpdPointsSum(cpdCategorys)} />
                  <span>/</span>
                  <CpdPoints cpdPoints={industryCpdPoints} />
                </p>
              </Col>
            </FormGroup>
          </div>
        </Col>
      </Row>
    </div>
  );

export default compose(
  setPropTypes({
    cpdCategorys: PropTypes.array,
    industryCpdPoints: PropTypes.number,
    isLoading: PropTypes.bool,
    onCpdCategorysChange: PropTypes.func,
    validation: PropTypes.object,
    validationMessages: PropTypes.object,
    planLocked: PropTypes.bool
  }),
  branch(
    fp.get('isLoading'),
    renderComponent(Loading)
  ),
  branch(
    fp.flow(fp.get('cpdCategorys'), fp.isEmpty),
    renderComponent(() => (
      <h2 className='text-center'>
        Pick CPD categories to allocate CPD hours.
      </h2>
    ))
  )
)(CpdAllocation);



// WEBPACK FOOTER //
// ./src/containers/partials/cpd-settings/cpd-allocation.js